<template>
    <header class="proc-header-compact">
        <div class="proc-header-main">
            <div class="proc-header-info">
                <h2>{{ processo?.nmprocesso || 'Processo' }}</h2>

                <div class="proc-header-line">
                    <span>Processo #{{ processo?.id || '-' }}</span>
                    <span v-if="processo?.protocolo">Protocolo: {{ processo.protocolo }}</span>
                    <span>{{ processo?.nmsim || '-' }}</span>
                    <span>{{ processo?.nmestabelecimento || '-' }}</span>
                    <span>{{ processo?.cpfcnpj || '-' }}</span>
                </div>

                <div class="proc-header-line">
                    <strong>Etapa:</strong>
                    <span>{{ etapa?.ordem || '-' }} - {{ etapa?.nmetapa || '-' }}</span>

                    <strong>Status:</strong>
                    <span>{{ etapa?.nmstatus || processo?.nmstatus_etapa || '-' }}</span>

                    <strong>Perfil:</strong>
                    <span>{{ perfil?.nmperfil || 'Sem perfil na etapa' }}</span>
                </div>
            </div>

            <div class="proc-resumo-box">
                <div>
                    <strong>{{ resumo.qtd_anexo_ok }}/{{ resumo.qtd_anexo_total }}</strong>
                    <span>Anexos</span>
                </div>
                
                <div>
                    <strong>{{ resumo.qtd_doc_ok }}/{{ resumo.qtd_doc_total }}</strong>
                    <span>Formulários</span>
                </div>
            </div>
        </div>

        <div class="proc-flow-compact">
            <span>← {{ etapaAnterior?.nmetapa || 'Anterior não informada' }}</span>
            <strong>{{ etapa?.nmetapa || '-' }}</strong>
            <span>{{ etapaProxima?.nmetapa || 'Próxima não informada' }} →</span>
        </div>
    </header>
</template>

<script setup>
defineProps({
    processo: { type: Object, default: null },
    etapa: { type: Object, default: null },
    perfil: { type: Object, default: null },
    etapaAnterior: { type: Object, default: null },
    etapaProxima: { type: Object, default: null },
    resumo: {
        type: Object,
        default: () => ({
            qtd_doc_total: 0,
            qtd_doc_ok: 0,
            qtd_anexo_total: 0,
            qtd_anexo_ok: 0,
        }),
    },
});
</script>
